var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToastIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 6.66732H10.6668V8.00065H9.3335V6.66732ZM9.3335 9.33398H10.6668V13.334H9.3335V9.33398ZM10.0002 3.33398C6.32016 3.33398 3.3335 6.32065 3.3335 10.0007C3.3335 13.6807 6.32016 16.6673 10.0002 16.6673C13.6802 16.6673 16.6668 13.6807 16.6668 10.0007C16.6668 6.32065 13.6802 3.33398 10.0002 3.33398ZM10.0002 15.334C7.06016 15.334 4.66683 12.9406 4.66683 10.0007C4.66683 7.06065 7.06016 4.66732 10.0002 4.66732C12.9402 4.66732 15.3335 7.06065 15.3335 10.0007C15.3335 12.9406 12.9402 15.334 10.0002 15.334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastIcon);
export default __webpack_public_path__ + "static/media/toast-icon.c25f96df232ce1b4ad5a8e6312029fc5.svg";
export { ForwardRef as ReactComponent };